
import { localDataExam, } from 'util/setLocalStorageTesting'
import { message } from 'antd'

export const enterOldTesting = (user, props, data) => {
  try {
    const LSExam = localDataExam.get(props?.groupId)
    let setState = {
      data: LSExam.data,
      groupId: LSExam?.groupId,
      time : LSExam.data?.testingDuration?.endTimestamp,
      typeExam: 'groupExam',
      newStart : true
    }
    message.success(`เข้าสู่ข้อสอบ ${LSExam?.dataQuestion.examDetail.name} ที่ทำค้างไว้`, [3])
    return props?.history?.push({ pathname: `/testing/${LSExam.data.id}?groupId=${data.groupId}`, state: setState, search : 'typeExam=groupExam'  })
  } catch (err) {
    message.error('เกิดข้อผิดพลาดก่อนเข้าทำข้อสอบ', [3])
    return props?.props?.history.goBack()
  }
}